// extracted by mini-css-extract-plugin
module.exports = {"component":"LinkButton_component__1lcqa","component_ghost":"LinkButton_component_ghost__396er","component_disabled":"LinkButton_component_disabled__1cM8P"};